// Where the visitor is — answered on the server too.
//
// Public site pages are rendered on the server first (resources/js/
// ssr.js) and then hydrated, and hydration ADOPTS the server's
// attributes rather than recomputing them. So an href built from
// `window.location` while rendering, with a `typeof window` fallback of
// '' on the server, does not merely start out different: it STAYS the
// server's version after the page comes alive. The donate button lost
// its /site/{slug} prefix and its return path that way, and the
// template preview bar's links became '#', on every server-rendered
// page.
//
// The server knows the URL — it is the Inertia page's own `url`, which
// is the path in the visitor's address bar on a vanity domain and on a
// /site/{slug} preview alike — so ssr.js hands it over before each
// render. Renders are one at a time there, so a module-level value is
// the current request's.
//
// Read this, not window.location, anywhere the answer reaches the
// markup. Code in onMounted or an event handler can keep reading window.
let serverUrl = '/';

export function setServerUrl(url) {
    serverUrl = typeof url === 'string' && url.startsWith('/') ? url : '/';
}

/** `{ pathname, search, href }` of the page being rendered; `href` is root-relative on the server. */
export function siteLocation() {
    if (typeof window !== 'undefined') return window.location;
    const u = new URL(serverUrl, 'http://server.invalid');
    return { pathname: u.pathname, search: u.search, hash: '', href: u.pathname + u.search };
}

// The prefix the SERVER says this host puts in front of the site's
// paths. Only the public host sends one (`site_prefix`, /{slug} on
// go.trailsiq.com): there the path alone cannot tell /ridgeline from a
// page called /about on a club's own domain. Set per render in ssr.js
// and from the page props in app.js, like the URL above.
let hostPrefix = null;

export function setSitePrefix(prefix) {
    hostPrefix = typeof prefix === 'string' && /^\/[a-z0-9-]+$/.test(prefix) ? prefix : null;
}

/**
 * `/site/{slug}` on the preview URL, `/{slug}` on the public host, ''
 * on the organization's own domain.
 */
export function sitePrefix() {
    if (hostPrefix) return hostPrefix;
    const m = siteLocation().pathname.match(/^\/site\/([a-z0-9-]+)(?:\/|$)/);
    return m ? `/site/${m[1]}` : '';
}

/** Whether a root-relative href already carries the site's prefix — query and hash aside. */
export function isUnderPrefix(href, prefix) {
    if (!prefix) return false;
    const path = String(href).split(/[?#]/)[0];
    return path === prefix || path.startsWith(`${prefix}/`);
}
